import {
    createComment,
    createForum,
    createForumComment,
    deleteForum,
    deleteForumComment,
    getCommentsRelatedToForum,
    getForum,
    getForumsData,
    listenToForumUpdate,
    listenToForumUpdated, markForumAsRead,
    updateForum,
    updateForumComment,
    updateForumVisibility,
    voteCommentInForum
} from "@/services/ForumsService";
import { leaveMaterialsServiceReverbPrivateChannel } from "../services/api/MaterialsApiService.js";

const state = {
    forumsData: [],
    forumData: null,
    forumDataToUpdate: null,
    commentsRelatedToForum: {},
    commentIdToAnswer: null,
    commentIdToUpdate: null,
    reverbChannel: null,
    notReadCommentsAmount: 0
}

const getters = {
    getNotReadCommentsAmount: (state) => state.notReadCommentsAmount,
    getForumAvailableForInteractions: (state) => state.forumData.status === 'open' && state.forumData.is_visible,
    getReverbChannel: (state) => state.reverbChannel,
    getCommentIdToUpdate: (state) => state.commentIdToUpdate,
    getForumDataToUpdate: (state) => state.forumDataToUpdate,
    getReactionEnabledInForum: (state) => state?.forumData?.votes_enable,
    getCommentIdToAnswer: (state) => state.commentIdToAnswer,
    getForumData: (state) => state.forumData,
    getForumsData: (state) => state.forumsData,
    getCommentsRelatedToForum: (state) => state.commentsRelatedToForum
}

const mutations = {
    setNotReadCommentsAmount(state, data) {
        state.notReadCommentsAmount = data || 0
    },

    setReverbChannel(state, data) {
        state.reverbChannel = data || null
    },

    updateForumComment(state, data) {
        if (data) {
            let statePointer = state.commentsRelatedToForum
            if (data?.path && data.path.length > 0) {
                const hashmapKeys = data.path
                hashmapKeys.forEach((key, index) => {
                    statePointer = index === 0 ?
                        statePointer[key]
                        : statePointer?.thread[key] || null
                })

                if (statePointer && statePointer?.thread && statePointer.thread[`id-${data.id}`]) {
                    const originalData = statePointer.thread[`id-${data.id}`]
                    if (data.updatedByWS && originalData?.user_vote) {
                        const originalUserVote = originalData.user_vote
                        const {user_vote, ...rest} = data
                        data = {...rest, user_vote: originalUserVote}
                    }

                    const {thread, ...rest} = data
                    data = {...rest, thread: originalData.thread}

                    statePointer.thread[`id-${data.id}`] = data
                }
            } else {
                if (statePointer && statePointer[`id-${data.id}`]) {
                    const originalData = statePointer[`id-${data.id}`]
                    if (data.updatedByWS && originalData?.user_vote) {
                        const originalUserVote = originalData.user_vote
                        const {user_vote, ...rest} = data
                        data = {...rest, user_vote: originalUserVote}
                    }

                    const {thread, ...rest} = data
                    data = {...rest, thread: originalData.thread}

                    statePointer[`id-${data.id}`] = data
                }
            }
        }

    },

    setCommentIdToUpdate(state, data) {
        state.commentIdToAnswer && (state.commentIdToAnswer = null)
        state.commentIdToUpdate = data || null
    },

    updateForumCommentVisibility(state, data) {
        let statePointer = state.commentsRelatedToForum
        if (data.path) {
            const hashmapKeys = data.path
            hashmapKeys.forEach((key, index) => {
                statePointer = index === 0
                    ? statePointer[key]
                    : statePointer.thread[key]
            })
            statePointer = statePointer.thread[`id-${data.forumCommentId}`]
        } else {
            statePointer = statePointer[`id-${data.forumCommentId}`]
        }

        statePointer.status = data.is_visible ? 'visible' : 'hidden'
    },

    deleteForumComment(state, data) {
        let statePointer = state.commentsRelatedToForum

        if (data.path) {
            const hashmapKeys = data.path
            hashmapKeys.forEach((key, index) => {
                statePointer = index === 0 ?
                    statePointer[key]
                    : statePointer?.thread[key] || null
            })

            if (!statePointer || !statePointer?.thread) return

            statePointer = statePointer?.thread[`id-${data.forumCommentId}`] || null
        } else {
            statePointer = statePointer[`id-${data.forumCommentId}`] || null
        }

        if (!statePointer) return

        statePointer.deleted_at = new Date()
        if (state?.forumData && state.forumData.total_comments > 0) {
            state.forumData.total_comments--
        }
    },

    removeThreadComments(state, data) {
        let statePointer = state.commentsRelatedToForum

        if(data.path && Array.isArray(data.path) && data.path.length > 0) {
            const commentPath = data.path
            commentPath.forEach((key, index) => {
                statePointer = index === 0 ?
                statePointer[key] || null
                : statePointer.thread[key] || null
            })

            statePointer = statePointer.thread[`id-${data.commentId}`]
        } else {
            statePointer = statePointer[`id-${data.commentId}`]
        }

        if(statePointer) {
            if(data.removeAll) {
                statePointer.thread = {}
                return
            }

            const commentKeys = Object.keys(statePointer.thread)
            const commentAmountToDelete = ((data.pagesAmount - 1) * 10) + (commentKeys.length % 10 || 10)
            const commentKeysToDelete = commentKeys.slice(-commentAmountToDelete)
            commentKeysToDelete.forEach((key) => {
                statePointer?.thread[key] && (delete statePointer.thread[key])
            })
        }
    },

    incrementThreadComments(state, data) {
        if (!data || Array.isArray(data)) return

        const firstObjectInHash = Object.values(data)[0]
        const hashMapKeys = firstObjectInHash.path
        let statePointer = state.commentsRelatedToForum

        hashMapKeys.forEach((key, index) => {
            statePointer = index === 0 ? statePointer[key]
                : statePointer.thread[key]
        })

        const newThreadKeys = Object.keys(data)
        newThreadKeys.forEach((key) => {
            statePointer.thread[`${key}`] = data[key]
        })
    },

    updateCommentVotes(state, data) {
        if (!data) return
        let statePointer = state.commentsRelatedToForum
        if (data?.path) {
            data.path.forEach((commentKey, index) => {
                statePointer = index === 0 ?
                    statePointer[commentKey]
                    : statePointer?.thread[commentKey] || null
            })

            statePointer = statePointer?.thread[`id-${data.commentId}`] || null
        } else {
            statePointer = statePointer[`id-${data.commentId}`] || null
        }

        if (!statePointer) return

        const voteStatus = Boolean(data.vote)
        const voteExists = statePointer.user_vote
        const voteUpdated = data?.voteUpdated || (voteExists && data.votedByUser)

        if (data.votedByUser) {
            if (!statePointer.user_vote) {
                statePointer.user_vote = {
                    vote: null
                }
            }
            statePointer.user_vote.vote = voteStatus
        }

        if (!voteStatus) {
            statePointer.votes -= voteUpdated ? 2 : 1
            return
        }

        statePointer.votes += voteUpdated ? 2 : 1
    },

    incrementCommentsCounter(state) {
        state.forumData && (state.forumData.total_comments++)
    },

    setCommentIdToAnswer(state, data) {
        state.commentIdToUpdate && (state.commentIdToUpdate = null)
        state.commentIdToAnswer = data || null
    },

    setCommentsRelatedToForum(state, data) {
        Array.isArray(data) && (data = {})
        state.commentsRelatedToForum = data
    },

    createForumComment(state, data) {
        Array.isArray(state.commentsRelatedToForum) && (state.commentsRelatedToForum = {})

        if (data.path.length === 0) {
            state.commentsRelatedToForum[`id-${data.id}`] = data
            return
        }

        const commentPath = data.path
        let statePointer = state.commentsRelatedToForum
        commentPath.forEach((key, index) => {

            statePointer = index === 0 ?
                statePointer[key] :
                statePointer?.thread[key] || null
        })

        if (!statePointer || !statePointer?.thread) return

        statePointer.thread[`id-${data.id}`] = {...data}
        statePointer.thread_lenght++
    },

    setForumsData(state, data) {
        state.forumsData = data || []
    },

    setForumData(state, data) {
        state.forumData = data || null
    },

    setForumDataToUpdate(state, data) {
        if (data === state?.forumData?.id) {
            state.forumDataToUpdate = state.forumData
            return
        }

        state.forumDataToUpdate = null
    },

    deleteForum(state, forumId) {
        const forumIndex = state.forumsData.findIndex((forum) => forum.id === forumId)
        forumIndex !== -1 && (state.forumsData.splice(forumIndex, 1))
    },

    updateForum(state, data) {
        const forumIndex = state.forumsData.findIndex((forum) => forum.id === data.id)
        if (forumIndex !== -1) {
            state.forumsData[forumIndex] = data
            state.forumData = data
        }
    },

    incrementForumsData(state, data) {
        data && (state.forumsData = [...state.forumsData, ...data])
    }
}

const actions = {
    processIncomingComment({commit, dispatch, rootGetters, state}, payload) {
        const userId = rootGetters.getId
        const authorId = payload?.comment?.author?.id

        if (userId !== authorId) {
            try {
                commit('createForumComment', payload.comment)
                commit('incrementCommentsCounter')
                dispatch('markForumAsRead', state?.forumData?.id)
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', {text: "Ocorreu um erro ao processar novo comentário"})
            }
        }
    },

    processIncomingCommentMutation({commit, dispatch, rootGetters}, payload) {
        const userId = rootGetters.getId
        const authorId = payload?.comment?.modified_by?.id

        if (userId !== authorId) {
            try {
                commit('updateForumComment', {...payload.comment, updatedByWS: true})
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', {text: "Ocorreu um erro ao processar a atualização de comentário"})
            }
        }

    },

    processIncomingCommentVote({commit, dispatch, rootGetters}, payload) {
        const userId = rootGetters.getId
        const authorId = payload?.vote?.user?.id

        if (userId !== authorId) {
            try {
                const voteData = payload.vote
                commit('updateCommentVotes', {
                    commentId: voteData.comment_id,
                    vote: voteData.vote,
                    votedByUser: false,
                    ...(payload.eventName === '.vote.changed') && {voteUpdated: true},
                    ...((payload.path) && payload.path.length > 0) && {path: payload.path}
                })
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', {text: "Ocorreu um erro ao processar novo voto em comentário"})
            }
        }
    },

    processIncomingCommentDeleted({commit, dispatch, rootGetters}, payload) {
        const userId = rootGetters.getId
        const authorId = payload?.comment?.author?.id

        if (userId !== authorId) {
            try {
                commit('deleteForumComment', {
                    forumCommentId: payload.comment_id,
                    ...((payload.path) && payload.path.length > 0) && {path: payload.path}
                })
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', {text: "Ocorreu um erro ao processar comentário deletado"})
            }
        }
    },

    notifyNotAvailableMessage({commit, dispatch}) {
        dispatch('toastfy/activeErrorNotification', {text: "Este fórum está indisponível para interações"})
    },

    setReverbChannel({commit}, payload) {
        commit('setReverbChannel', payload)
    },

    setCommentIdToUpdate({commit}, payload) {
        commit('setCommentIdToUpdate', payload)
    },

    setForumDataToUpdate({commit}, payload) {
        commit("setForumDataToUpdate", payload)
    },

    removeThreadComments({commit}, payload) {
        commit('removeThreadComments', payload)
    },

    setCommentIdToAnswer({commit}, payload) {
        commit('setCommentIdToAnswer', payload)
    },

    async getForumsData({commit, dispatch}, payload) {
        try {
            const response = await getForumsData(payload)

            payload?.incrementWithData ? commit('incrementForumsData', response.data)
            : commit('setForumsData', response.data)

            commit('setNotReadCommentsAmount', response?.meta?.total_unread_comments)
        } catch (error) {
            dispatch('toastfy/activeErrorNotification', {text: error})
        }
    },

    async createForum({commit, dispatch}, payload) {
        try {
            dispatch('setLoadingState', {loadignState: true, loadingView: 'Forum Management View'})
            const response = await createForum(payload)
            return response.data
        } catch (error) {
            dispatch('toastfy/activeErrorNotification', {text: error})
        } finally {
            dispatch('setLoadingState', {loadignState: false})
        }
    },

    async getForum({commit, dispatch}, payload) {
        try {
            const response = await getForum(payload)
            commit('setForumData', response.data)
        } catch (error) {
            dispatch('toastfy/activeErrorNotification', {text: error})
        }
    },

    async createForumComment({commit, dispatch}, payload) {
        try {
            dispatch('setLoadingState', {loadignState: true, loadingView: 'Forum Management View'})
            const response = await createForumComment(payload)
            commit("createForumComment", response?.data || null)
            commit('incrementCommentsCounter')
        } catch (error) {
            dispatch('toastfy/activeErrorNotification', {text: error})
        } finally {
            dispatch('setLoadingState', {loadignState: false})
        }
    },

    async getCommentsRelatedToForum({commit, dispatch}, payload) {
        try {
            const response = await getCommentsRelatedToForum(payload)
            commit(payload.incrementThreadComments ? 'incrementThreadComments' : 'setCommentsRelatedToForum', response.data)
        } catch (error) {
            dispatch('toastfy/activeErrorNotification', {text: error})
        }
    },

    async voteCommentInForum({commit, dispatch}, payload) {
        try {
            await voteCommentInForum(payload)
            commit('updateCommentVotes', {...payload, votedByUser: true})
        } catch (error) {
            dispatch('toastfy/activeErrorNotification', {text: error})
        }
    },

    async deleteForum({commit, dispatch}, payload) {
        try {
            dispatch('setLoadingState', {loadignState: true, loadingView: 'Forum Management View'})
            await deleteForum(payload)

            if (!payload.deletedInForumView) {
                commit('deleteForum', payload.forumId)
                dispatch('toastfy/activeSuccesNotification', {text: "Forúm excluido com sucesso!"})
                const forumsPerPage = 5
                const pageToRequest = (payload?.forumsDropdownPage * forumsPerPage)

                const requestData = {
                    sort: 'created_at|desc',
                    page: pageToRequest,
                    perPage: 1,
                    disciplineId: payload?.disciplineId || null,
                    incrementWithData: true
                }
        
                dispatch('getForumsData', requestData)
            } else { 
                dispatch('toastfy/setToastDataToDispatchBetweenRoutes', {
                    type: 'success',
                    message: "Fórum excluido com sucesso!"
                })
            }


            return true
        } catch (error) {
            dispatch('toastfy/activeErrorNotification', {text: error})
        } finally {
            dispatch('setLoadingState', {loadignState: false})
        }
    },

    async updateForum({commit, dispatch}, payload) {
        try {
            dispatch('setLoadingState', {loadignState: true, loadingView: 'Forum Management View'})
            const response = await updateForum(payload)

            if(payload.updatedVisibility) {
                commit('updateForum', response.data)
                dispatch('toastfy/activeSuccesNotification', {text: "Fórum atualizado com sucesso!"})
            } else {
                dispatch('toastfy/setToastDataToDispatchBetweenRoutes', {
                    type: 'success',
                    message: "Fórum atualizado com sucesso!"
                })  
            }

            return true
        } catch (error) {
            dispatch('toastfy/activeErrorNotification', {text: error})
        } finally {
            dispatch('setLoadingState', {loadignState: false})
        }
    },

    async deleteForumComment({commit, dispatch}, payload) {
        try {
            dispatch('setLoadingState', {loadignState: true, loadingView: 'Forum View'})
            await deleteForumComment(payload.forumCommentId)
            commit('deleteForumComment', payload)
            dispatch('toastfy/activeSuccesNotification', {text: "Comentário excluido com sucesso!"})
        } catch (error) {
            dispatch('toastfy/activeErrorNotification', {text: error})
        } finally {
            dispatch('setLoadingState', {loadignState: false})
        }
    },

    async updateForumCommentVisibility({commit, dispatch}, payload) {
        try {
            await updateForumVisibility(payload)
            commit("updateForumCommentVisibility", payload)
            dispatch('toastfy/activeSuccesNotification', {text: "Visibilidade de comentário alterada com sucesso!"})
        } catch (error) {
            dispatch('toastfy/activeErrorNotification', {text: error})
        }
    },

    async updateForumComment({commit, dispatch}, payload) {
        try {
            dispatch('setLoadingState', {loadignState: true, loadingView: 'Forum View'})
            const response = await updateForumComment(payload)
            commit('updateForumComment', response.data)
            dispatch('toastfy/activeSuccesNotification', {text: "Comentário atualizado com sucesso!"})
        } catch (error) {
            dispatch('toastfy/activeErrorNotification', {text: error})
        } finally {
            dispatch('setLoadingState', {loadignState: false})
        }
    },

    async listenToForumUpdate({commit, dispatch}, payload) {
        try {
            let forumChannel = `forum.${payload.forumId}`
            payload.userRole === 'student' && (forumChannel += '.student')
            commit('setReverbChannel', forumChannel)

            const forumEvents = [
                {eventName: '.comment.sent', eventAction: 'processIncomingComment'},
                {eventName: '.comment.updated', eventAction: 'processIncomingCommentMutation'},
                {eventName: '.comment.deleted', eventAction: 'processIncomingCommentDeleted'},
                {eventName: '.vote.made', eventAction: 'processIncomingCommentVote'},
                {eventName: '.vote.changed', eventAction: 'processIncomingCommentVote'},
            ]

            await listenToForumUpdate(forumChannel, forumEvents)
        } catch (error) {
            dispatch('toastfy/activeErrorNotification', {text: error})
        }
    },

    async leaveForumChannel({commit, dispatch, state}) {
        try {
            leaveMaterialsServiceReverbPrivateChannel(state.reverbChannel)
        } catch (error) {
            dispatch('toastfy/activeErrorNotification', {text: error})
        }
    },

    async markForumAsRead({commit, dispatch}, payload) {
        try {
            await markForumAsRead(payload)
        } catch (error) {
            dispatch('toastfy/activeErrorNotification', {text: error})
        }
    },
}

export default {
    state,
    getters,
    mutations,
    actions
}